import { render, staticRenderFns } from "./ResourceDialog.vue?vue&type=template&id=00920c52&scoped=true&"
import script from "./ResourceDialog.vue?vue&type=script&lang=js&"
export * from "./ResourceDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDialog.vue?vue&type=style&index=0&id=00920c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00920c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00920c52')) {
      api.createRecord('00920c52', component.options)
    } else {
      api.reload('00920c52', component.options)
    }
    module.hot.accept("./ResourceDialog.vue?vue&type=template&id=00920c52&scoped=true&", function () {
      api.rerender('00920c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createFlow/build/ResourceDialog.vue"
export default component.exports